module.exports = __webpack_public_path__ + "static/hero-home-mobile-f30513c43cae258376ee845f5c84776e.png";